type PaymentMethods = {
  achAccountNumberLast4: string;
  achAuthorized: boolean;
  billingFrequency: number;
  blockedBilling: boolean;
  paymentCurrency: string;
  paymentThreshold: number;
  paymentType: string;
  stripeAchSet: boolean;
  stripeAuthorized: boolean;
  stripeCcBrand: string;
  stripeCcExpMonth: number;
  stripeCcExpYear: number;
  stripeCcLast4: number;
  stripeCreditCardSet: boolean;
  stripePublishableKey: string;
  stripeToken: string;
};

export type PaymentMethodsJson = {
  ach_account_number: string;
  ach_authorized: boolean;
  billing_frequency: number;
  blocked_billing: boolean;
  payment_currency: string;
  payment_threshold: string;
  payment_type: string;
  stripe_ach_set: boolean;
  stripe_authorized: boolean;
  stripe_cc_brand: string;
  stripe_cc_exp_month: number;
  stripe_cc_exp_year: number;
  stripe_cc_last4: number;
  stripe_credit_card_set: boolean;
  stripe_publishable_key: string;
  stripe_token: string;
};

export enum PaymentMethodType {
  CreditCard = 'STRIPE',
}

export default PaymentMethods;
